import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Typography, styled, useTheme } from '@mui/material';
import usePagination from '@mui/material/usePagination/usePagination';

const HoveredTypo = styled(Typography)(({ theme }) => ({
  '&:hover': {
    color: `${theme.palette.primary.main} !important`,
    cursor: 'pointer',
  },
}));

const StyledTextButton = styled(Button)({
  color: 'black !important',
  fontSize: '16px',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: 'transparent',
  },
});

export const SdmPaginatorV5 = ({
  callBackFunction,
  totalPages,
  i18n,
  isSmDown,
  startPage = 1,
}) => {
  const theme = useTheme();
  const { items } = usePagination({
    count: totalPages,
    defaultPage: startPage,
  });

  const handleClick = ({ e, onClick, page, type, selected }) => {
    onClick(e);
    if (!selected) {
      callBackFunction && callBackFunction({ page, type });
    }
  };

  return (
    <nav>
      <ul
        style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          gap: isSmDown ? '3px' : '10px',
        }}
      >
        {items.map(({ page, type, selected, onClick, ...item }, index) => {
          let children = null;

          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = !isSmDown ? (
              <Typography
                variant={'body2-bold'}
                fontFamily={'Suisse-Intl'}
                style={{ paddingTop: 20 }}
              >
                …
              </Typography>
            ) : null;
          } else if (type === 'page') {
            children = !isSmDown ? (
              <HoveredTypo
                variant={'body2-bold'}
                fontFamily={'Suisse-Intl'}
                onClick={(e) =>
                  handleClick({ e, onClick, page, type, selected })
                }
                style={{
                  color: selected ? `${theme.palette.primary.main}` : `black`,
                  paddingTop: isSmDown ? 20 : 13,
                }}
                {...item}
              >
                {page}
              </HoveredTypo>
            ) : null;
          } else {
            children = (
              <StyledTextButton
                fontFamily={'Suisse-Intl'}
                onClick={(e) =>
                  handleClick({ e, onClick, page, type, selected })
                }
                {...item}
                variant="text"
                startIcon={
                  type === 'next' ? null : <ArrowBackIcon fontSize="small" />
                }
                endIcon={
                  type === 'next' ? <ArrowForwardIcon fontSize="small" /> : null
                }
                sx={{
                  ...(isSmDown && {
                    px: '5px !important',
                  }),
                }}
              >
                {i18n.buttons[`${type}`]}
              </StyledTextButton>
            );
          }

          return <li key={index}>{children}</li>;
        })}
      </ul>
    </nav>
  );
};
